import { SxProps, Theme } from "@mui/material/styles";

const styles: SxProps<Theme> = [
  {
    "& .classNote": {
      whiteSpace: "nowrap",
    },
    "& .classNoteBold": {
      whiteSpace: "nowrap",
      fontWeight: "bold",
      fontStyle: "italic",
    },
  },
];

export default styles;
